export const PACKAGE_NAMESPACE = 'st-frontend';
export const PACKAGE_NAME = 'site';
